// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2qE5X","icon":"styles_icon__2sbmI"};